export const UPDATE_COMPANY_SETTINGS = "UPDATE_COMPANY_SETTINGS";
